import React from 'react';
import { useTranslation } from 'react-i18next';
import { visionImage } from '../mock';

const Vision = () => {
  const { t } = useTranslation();
  const paragraphs = t('vision.paragraphs', { returnObjects: true }) || [];
  const list = Array.isArray(paragraphs) ? paragraphs : [];

  return (
    <section id="vision" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2 className="font-serif font-light text-[#1B3A5C] text-4xl md:text-5xl lg:text-6xl tracking-tight mb-12">
          {t('vision.eyebrow', 'UNSERE VISION')}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          <div className="lg:col-span-3 space-y-6 text-[#34536b] leading-relaxed text-[15px]">
            {list.map((p, idx) => (
              <p key={p}>{p}</p>
            ))}
          </div>

          <div className="lg:col-span-2">
            <div className="relative overflow-hidden rounded-sm shadow-xl group">
              <img
                src={visionImage}
                alt="Vision"
                className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B3A5C]/30 to-transparent"></div>
            </div>
            <div className="mt-6 p-6 bg-[#f5f8fa] border-l-4 border-[#b8893d]">
              <p className="text-[#1B3A5C] font-serif text-lg italic">
                &ldquo;{t('vision.caption', 'Persönliche Betreuung. Fachliche Exzellenz. Verlässliche Partnerschaft.')}&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
